import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
// @ts-expect-error untyped import
import AreaChartIcon from '../components/shared/icons/AreaChartIcon';
// @ts-expect-error untyped import
import BarChartIcon from '../components/shared/icons/BarChartIcon';
// @ts-expect-error untyped import
import ColumnChartIcon from '../components/shared/icons/ColumnChartIcon';
// @ts-expect-error untyped import
import DataWellChartIcon from '../components/shared/icons/DataWellChartIcon';
// @ts-expect-error untyped import
import DonutChartIcon from '../components/shared/icons/DonutChartIcon';
// @ts-expect-error untyped import
import LineChartIcon from '../components/shared/icons/LineChartIcon';
// @ts-expect-error untyped import
import PieChartIcon from '../components/shared/icons/PieChartIcon';
// @ts-expect-error untyped import
import TableChartIcon from '../components/shared/icons/TableChartIcon';
// @ts-expect-error untyped import
import CombinationChartIcon from '../components/shared/icons/CombinationChartIcon';
// @ts-expect-error untyped import
import PivotTableChartIcon from '../components/shared/icons/PivotTableChartIcon';
// @ts-expect-error untyped import
import ScatterChartIcon from '../components/shared/icons/ScatterChartIcon';
// @ts-expect-error untyped import
import GaugeChartIcon from '../components/shared/icons/GaugeChartIcon';
const comboOption = {
  type: VisualTypes.COMBO,
  Icon: CombinationChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.COMBO',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.COMBO'
};
const pivotOption = {
  type: VisualTypes.PIVOT_TABLE,
  Icon: PivotTableChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.PIVOT_TABLE',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.PIVOT_TABLE'
};
export const scatterOption = {
  type: VisualTypes.SCATTER,
  Icon: ScatterChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.SCATTER.TEXT',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.SCATTER.TEXT'
};
export const RelationalReportVisualTypeOptions = [{
  type: VisualTypes.VERTICAL_BAR,
  Icon: ColumnChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.VERTICAL_BAR',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.VERTICAL_BAR'
}, {
  type: VisualTypes.HORIZONTAL_BAR,
  Icon: BarChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.HORIZONTAL_BAR',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.HORIZONTAL_BAR'
}, {
  type: VisualTypes.LINE,
  Icon: LineChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.LINE',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.LINE'
}, scatterOption, {
  type: VisualTypes.AREA,
  Icon: AreaChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.AREA',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.AREA'
}, {
  type: VisualTypes.DONUT,
  Icon: DonutChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.DONUT',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.DONUT'
}, {
  type: VisualTypes.PIE,
  Icon: PieChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.PIE',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.PIE'
}, {
  type: VisualTypes.TEXT,
  Icon: DataWellChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.TEXT',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.TEXT'
}, {
  type: VisualTypes.TABLE,
  Icon: TableChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.TABLE',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.TABLE'
}, comboOption, pivotOption, {
  type: VisualTypes.GAUGE,
  Icon: GaugeChartIcon,
  labelI18n: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypes.GAUGE',
  labelI18nMagicWand: 'reporting-ui-components.relationalReportVisualTypeOptions.visualTypesMagicWand.GAUGE'
}];
export const RelationalReportVisualTypeBadges = [];